import React, { useState } from 'react';

const WithdrawApplication = () => {
  const [reason, setReason] = useState('');

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const handleSubmit = () => {
    console.log("Withdraw reason:", reason);
    // Add further functionality here, like sending the reason to an API or updating state.
    alert("Application withdrawn for reason: " + (reason || "No reason provided"));
  };

  return (
    <>
      <div>Reason to withdraw (Optional)</div>
      <textarea
        value={reason}
        onChange={handleReasonChange}
        style={{
          width: '100%',
          height: '100px',
          marginTop: '10px',
          padding: '10px',
          borderRadius: '5px',
          border: '1px solid #D9D9D9'
        }}
        placeholder="Enter your reason here..."
      />
      <div>Are you sure you want to withdraw your application?</div>
      <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly'}}>
        <button
            onClick={handleSubmit}
            style={{
            marginTop: '10px',
            padding: '10px 20px',
            backgroundColor: 'grey',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
            }}
        >
            No
        </button>
        <button
            onClick={handleSubmit}
            style={{
            marginTop: '10px',
            padding: '10px 20px',
            backgroundColor: '#FBBD34',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
            }}
        >
            Yes
        </button>
      </div>
    </>
  );
};

export default WithdrawApplication;
